// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statistic-table{width:100%;border-collapse:separate;border-spacing:0}.statistic-table__head{position:sticky;top:0}.statistic-table__header{background-color:#fff;border-bottom:1px solid #26222a;padding:12px 16px}.statistic-table__row{border-bottom:1px solid #f2f1f4}.statistic-table__cell{padding:16px;border-bottom:1px solid #f2f1f4}.statistic-table__cell-flex{display:flex;align-items:center;gap:8px;flex-direction:row}.statistic-table__line{height:10px;background-color:red}", ""]);
// Exports
module.exports = exports;
